<template>
  <button @click="handleSettingsClick()" class="settings-btn" v-if="!isWidget">
    <Cog class="settings-btn__icon" />
  </button>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from 'vue-router';
import Cog from "@/components/icons/Cog.vue";
import { useGlobalStore } from "@/stores/globalStore";

const route = useRoute();
const globalStore = useGlobalStore();

const isWidget = computed(() => route?.name && route.name.includes('widget'));

const handleSettingsClick = () => {
  globalStore.toggleSettings();
};
</script>

<style lang="scss">
.settings-btn {
  background: none;
  border: none;
  cursor: pointer;
  position: absolute;
  top: 3.4rem;
  right: 3.4rem;
  z-index: 2;

  &__icon {
    g {
      transition: var(--button-icon-transition);
      path {
        stroke: var(--icon-color-default);
      }
    }

    &:hover {
      g {
        opacity: 1;
      }
    }
  }
}
</style>
